// extracted by mini-css-extract-plugin
module.exports = {"hidden":"liveChat_hidden__SdMlL","textEmphasis":"liveChat_textEmphasis__ZUbFG","liveChat":"liveChat_liveChat__t8pIM"};